import { useHasInsuranceVerification } from "hooks/featureFlags";

export const useInsuranceVerification = (): boolean => {
  return useHasInsuranceVerification();
};
